<template>
  <div v-if="descTemplate" class="instype-result-wrap">
    <liability
      :temp="descTemplate"
      :data="descData"
      :product-name-list="productNameList"
      :show-type="1"
      :kind="kind"
      @disShow="fetchDisData"
    >
      <a slot="disease-btn" class="disease-btn">病种</a>
    </liability>
  </div>
</template>

<script>
import ToggleTemp from 'components/toggleTemp/toggleTemp'
import Liability from 'components/liability/liability'

export default {
  name: 'InsResult',
  components: {
    ToggleTemp,
    Liability,
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
    productNameList: {
      type: Object,
      default: null,
    },
    kind: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      descTemplate: '',
      descData: '',
      disData: [],
      disActive: 0,
      disVisible: false,
      disHeader: '病种详情',
      disLink: '',
    }
  },
  watch: {
    template(newTemplate) {
      this.pageInit(newTemplate)
    },
  },
  created() {
    this.pageInit()
  },
  methods: {
    // 初始化
    pageInit(temp = this.template) {
      if (temp) {
        const {
          resultData: { insuranceTypeId, categorySort },
          card,
          diff,
          diffname,
          accountMap,
          insuredAge,
          liabilities,
          calData,
          categorySortList,
        } = temp

        this.descTemplate = {
          liabilities,
          diff,
          diffname,
          accountMap,
          insuredAge,
          insuranceTypeId,
          categorySort,
          categorySortList,
        }
        if (card) {
          this.descTemplate.name = card.name
        }
        this.descData = calData
      }
    },
    fetchDisData(path) {
      let { pidx, idx } = path

      let liabilities =
        this.descTemplate.liabilities[pidx].insuranceLiabilities[idx]
          .liabilities
      let diseaseAry = []
      liabilities.forEach((liab) => {
        let { title, link, detail } = liab.disease
        title &&
          diseaseAry.push({
            title,
            link,
            detail,
          })
      })

      this.disData = this._normalizeDisText(diseaseAry)
      this.disVisible = true
    },
    _normalizeDisText(list) {
      let ret = []
      list.forEach((dis, index) => {
        let detail = dis.detail
        detail = `${detail.replace(
          /\d+[\、|\.]/g,
          '</p><p><span>$&</span>'
        )}</p>`
        detail = detail.replace(/<\/p>/, '')
        ret.push({
          fType: dis.fType,
          detail: detail,
          title: dis.title,
        })
      })
      return ret
    },
  },
}
</script>
